import { ACTION, ARRAY } from '../../../utils/component-validations';
import {
  COMPONENT_STATE_ARGS,
  getDefaultValueFromMetadata,
  pickArgs,
} from '../../../utils/spds/metadata';
import { fn } from '@ember/helper';
import { gt, not, reads } from 'macro-decorators';
import { tracked } from '@glimmer/tracking';
import Super from './base.gjs';
import Tag from '../indicator/tag.gjs';
import styles from './multiselect-clear-filter.module.scss';

const METADATA = {
  component: 'Spds::Core::MultiselectClearFilter',
  description:
    'Shared button for clearing multiselect lists. Wraps SPDS::Tag component filter variant',
  name: 'Multiselect Clear Filter',
  meta: {
    ...pickArgs(COMPONENT_STATE_ARGS, ['disabled']).meta,
    clearSelection: {
      description: 'Action to be called when the clear button is clicked',
      required: true,
      type: ACTION,
    },
    selected: {
      defaultValue: [],
      description: 'Array of selected items',
      initialValue: [1, 2, 3],
      type: ARRAY,
    },
  },
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/blob/staging/addon/src/components/spds/core/multiselect-clear-filter.gjs',
  },
};

export default class SpdsCoreMultiselectClearFilter extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-multiselect-clear-filter';
  classesToMapToAttrs = ['hidden'];
  styles = styles;

  @tracked tagComponent;

  @gt('selectedCount', 0) hasMultiselectOptions;

  @not('hasMultiselectOptions') hidden;

  @reads('tagComponent.clearButton') clearButton;
  @reads('selected.length') selectedCount;

  get selected() {
    return this.args.selected ?? getDefaultValueFromMetadata(this.constructor.metadata, 'selected');
  }

  clearSelection = (...args) => {
    let evt = args.pop();

    evt.stopPropagation();
    evt.target.classList.remove('active');

    this.args.clearSelection(...args, evt);
  };
  <template>
    <Tag
      @disabled={{@disabled}}
      @label="{{this.selectedCount}} selected"
      @type="filter"
      @onClose={{this.clearSelection}}
      @registerComponent={{fn this.registerComponent "tagComponent"}}
      @unregisterComponent={{fn this.unregisterComponent "tagComponent"}}
      class={{this.classes}}
      data-test-spds-multiselect-clear-button
      {{this.validateArguments}}
      ...attributes
    />
  </template>
}

export const SPDS_CORE_MULTISELECT_CLEAR_FILTER_METADATA = SpdsCoreMultiselectClearFilter.metadata;
